import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { TariffStore } from './tariff.store';

export function provideTariff(): EnvironmentProviders {
    return makeEnvironmentProviders([
        provideAppInitializer(() => {
            const tariff = inject(TariffStore);
            return tariff.init();
        }),
    ]);
}
